'use strict'

// Product slider component
// TODO:
//  - slotting for left/right icons
//  - infinite loop optional
//  - transition properties are applied on individual elements (can't use css since duration is dynamic). We should use generated css instead (see paginator).
Vue.component('awe-product-slider', {
  props: {
    currentProductEan: {type: String},
    products: {type: Array, default: function(){return []}},
    defaultEan: {type: String},
    idType: {type: String}, // type of product id used to identify the selected product
    slideDuration: {type: Number, default: 600}, // transition time
    slideInterval: {type: Number, default: 0}, // if set, automatically slides
    noSiblings: {type: Boolean, default: true}, // whether to show previous/next products, or only current selection
    pagination:{type: Boolean, default: false}, // true to enable pagination mode
  },
  data: function(){
    return {
      // internal copy of products array. 
      // Allows delaying DOM updates by delaying assigment to this list in products watcher.
      _products: [],
      productIdx: -1, // index of currently selected product
      scrollStep: 0, // in pixels , amount to move when sliding from one product to another.
      scrollOffset: 0, // in pixels, current offset of the container, relative to its width.
      positionOffset: 0, // offset for container's left property, in pixels
      ready: false, // whether the container is ready to start sliding
      siblingsIdx: [], // array of indices of products adjacent to the current selection
      paginationRequested: false, // whether pagination-request event has been sent. Reset to false on product update.

      // internal property used for transition duration. That's because we sometimes need to modify this duration (unset it for touch preview move),
      // and modifying props is strongly discouraged. So use this internally, set from the public prop slideDuration and modified when needed.
      transitionDuration: 0,
      autoSlideItvId: null,
      pdtWidth: 0,
      transitionInProgress: false, // whether the .content node is currently transitioning.
      
       // if products are updated when a content transition is in progress,
       // we use this flag to assign _products during transitionEnd event, so that the scroll transition happens smoothly
       // without any of the DOM update coming in the way and messing the slide effect.
      upateProductsOnTransition: false,

      // whether delayed slide is currently in progress. Where there's only 3 items
      // in a carousel with siblings, sliding incurs some asynchronous DOM manipulation.
      // If we don't throttle sliding in such cases, it causes some corruption
      // (e.g. additional temp nodes not removed, node order not respected) (API-3293).
      // This property is set & reset in these cases, and a slide is done only when it is false.
      // This does not impact sliders that do not show siblings, or ones with more than 3 products.
      _delayedSlideWip: false,

      resizeObs: null, // resize observer, to recompute offsets when component is resized.
      i18n: window.i18n,
    }
  },
  computed: {
    // style applied to the container
    ctnrStyle: function(){
      const stl = {
        transform: `translateX(${this.scrollOffset}px)`,
        left: this.positionOffset + 'px',
        transition: this.ready ? `transform ${this.transitionDuration}ms` : 'none'
      }
      if (this._noSiblings)
        stl.width = 100 * (this.$data._products ? this.$data._products.length : 1) + '%'
      return stl
    },

    pdtStyle: function(){
      if (this.noSiblings)
        return {}
      else{
        return {width: `${this.pdtWidth.toFixed(1)}px`}
      }
    },

    // this setting depends on public property but is overridden if not enough products,
    // so we need a private intermediate prop.
    _noSiblings: function(){
      if (!this.$data._products)
        return true
      else
        return this.$data._products.length <= 2 || this.noSiblings
    },

    hideSlideButtons: function(){
      return !this.$data._products || this.$data._products.length  < 2
    },

    currentLabel: function(){
      if (this.productIdx === -1)
        return ''
      else{
        let p = this.$data._products[this.productIdx]

        if (!p) return ''

        let l = p.name
        if (p.pkg)
          l += ' - ' + p.pkg
        return l
      }
    },

    previousLabel: function(){
      let prevIdx
      if (this.productIdx === -1)
        return

      if (this.productIdx > 0)
        prevIdx = this.productIdx - 1
      else
        prevIdx = this.$data._products.length - 1
      return this.$data._products[prevIdx] && `${this.$data._products[prevIdx].name} ${this.$data._products[prevIdx].pkg}` || ''
    },
    nextLabel: function(){
      let nextIdx
      if (this.productIdx === -1)
        return

      if (this.productIdx < this.$data._products.length - 1)
        nextIdx = this.productIdx + 1
      else
        nextIdx = 0
      return this.$data._products[nextIdx] && `${this.$data._products[nextIdx].name} ${this.$data._products[nextIdx].pkg}` || ''
    },

  },
  watch: {
    products: {
      handler(val) {
        this.paginationRequested = false;

        if (!this.pagination || !this.transitionInProgress) {
          this.$data._products = val;
        } else {
          this.upateProductsOnTransition = true;
        }        
      },
      // - trigger on products initalization
      // - needed to ensure this.$data._products is assigned a value on remount
      immediate: true 
    },
    '$data._products': function(val, old){
      let same = true
      
      // node order & siblings bindings need to be changed only if array length changes
      if (val && old && val.length !== old.length){
        this.resetNodeList()
        this.updateSiblings(false)
        same = false
      }

      let i = 0

      // if new & old arrays have same length, traverse them to check if they're identical.
      // re-init only if there's some difference. This is cheaper (time-wise) than running init each time.
      while(same && i < val.length){
        if (!val[i] || !old[i] || val[i].id !== old[i].id)
          same = false
        i++
      }
      if (!same){
        this.init()

        // _noSiblings could change with product change
        // ensure observer is attached to proper elements
        this.attachObserver()
      }
    },
    defaultEan: function(){ this.init() },
    productIdx: function(val, old){
      this.updateSiblings(old === -1)
    }
  },
  created: function(){
    if (window.ResizeObserver){
      // instanciates a single observer that will handle both container & product resizes.
      this.resizeObs = new ResizeObserver(entries => {
        // console.debug(`resize ${entries.length} entries`, Date.now(), entries[0])
        for (let i = 0; i < entries.length; i++){
          const entry = entries[i]
          if (entry.target.classList.contains('ctnr')) {
            this.pdtWidth = entry.contentRect.width / 3
            this.scrollStep = entry.contentRect.width / 3
          }
            
          else if (entry.target.classList.contains('pdt')) {
            this.pdtWidth = entry.contentRect.width
            this.scrollStep = entry.contentRect.width
          }
            
        } 
      })
    }
  },
  mounted: function(){
    this.transitionDuration = this.slideDuration

    // if slide interval is set, trigger automatic sliding
    // TODO: this is not updated if slideInterval changes after mount. Probably needs watchers on slideInterval & products.length to create/clear the interval when needed.
    if (this.slideInterval){
      this.autoSlideItvId = setInterval(() => {
        if (this.$data._products && this.$data._products.length < 2) // cancel autoslide if only one product
          return
        this.select(1, true)
      }, Math.abs(this.slideInterval))
    }
    
    this.attachObserver()

    // when pagination is enabled, we need to monitor the content node transitions,
    // so as to delay product updates while one is in progress, to avoid slider thrashing.
    if (this.pagination){
      const contentNd = this.$el.getElementsByClassName('content')[0]
      contentNd.addEventListener('transitionstart', e => {
        if (e.target === e.currentTarget && e.propertyName === 'transform')
          this.transitionInProgress = true
      })
      contentNd.addEventListener('transitionend', e => {
        if (e.target === e.currentTarget && e.propertyName === 'transform'){
          this.transitionInProgress = false

          if (this.upateProductsOnTransition){
            this.$data._products = this.products
            this.upateProductsOnTransition = false
          }
        }
      })
    }

    this.init()
  },
  updated: async function(){
    // compute product width dynamically
    // Resizing product is done with ResizeObserver when available.
    // Doing it in updated callback is only for browser that do not support the ResizeObserver (IE11 && Firefox android 68)
    if (window.ResizeObserver || this.noSiblings) return
    await this.$nextTick()

    const ctnrWidth = this.$el.getElementsByClassName('ctnr')[0].getBoundingClientRect().width,
          contentNd = this.$el.getElementsByClassName('content')[0],
          contentWidth = contentNd.getBoundingClientRect().width

    if (this.pdtWidth !== ctnrWidth / 3)
      this.pdtWidth = (ctnrWidth) / 3

    // IE11 bug: content node width is at most that of its parent, ctnr node, which breaks
    // all offset computations.
    // fix by checking both wides, and if they match we force the node to fit its content.
    if (contentWidth === ctnrWidth)
      contentNd.style.width = (this.pdtWidth * this.$data._products.length).toFixed(1) + 'px'
  },
  methods: {
    // sets default selection when product list or default ean changes.
    // adjusts some style variables based on product count
    init: async function(){
      this.ready = false
      if (!this.$data._products || !this.$data._products.length) return

      let productId, idType
      if (this.currentProductEan) {
        // current product ean is always a gtin
        productId = this.currentProductEan
        idType = 'gtin'
      } else if (this.defaultEan) {
        productId = this.defaultEan
        idType = this.idType
      }
      if (productId)
        this.productIdx = Math.max(0, this.$data._products.findIndex(pdt => Utils.isDefaultProduct(pdt, productId, idType)))
      else if (this.productIdx === -1){
        this.productIdx = 0
      }

      await this.$nextTick()

      // API-3288: content node width depends on every product width. this is set by ResizeObserver when available.
      // But when the tab is inactive, the observer callback does not fire (on blink-based browsers at least).
      // So pdtWith is 0, content width is 0, and positionning is f****d up.
      // The fix is to compute pdtWidth explicitely at init, so as to not depend on observer.
      const ctnrWidth = this.$el.getElementsByClassName('ctnr')[0].getBoundingClientRect().width

      if (!this.noSiblings)
        this.pdtWidth = ctnrWidth / 3

      await this.$nextTick()
      const contentWidth = this.$el.getElementsByClassName('content')[0].getBoundingClientRect().width
      this.scrollStep = this.$el.querySelector('.pdt').getBoundingClientRect().width

      // currently selected product must be in the middle of the container.
      // if number of products is even, scroll offset is not 50% but 50% plus half the product node's width
      let pdtOffset = 0
      if  (this.$data._products.length % 2 === 0)
          pdtOffset = this.scrollStep / 2
      this.reorderNodes()

      this.scrollOffset = - contentWidth / 2 + pdtOffset
      this.positionOffset = ctnrWidth / 2

      // console.debug(`ctnr ${ctnrWidth}  content ${contentWidth}`)
      // console.debug(`pdtOffset: ${pdtOffset}  scrollOffset: ${this.scrollOffset}  posOffset ${this.positionOffset}`)

      // add transition rule with delay, so that there's no transition when setting the default item.
      setTimeout(() => {
        this.ready = true
      }, 100)

      const pdtNds = this.$el.getElementsByClassName('pdt')
      for (let nd of pdtNds){
        nd.style.transition = `opacity ${this.transitionDuration}ms`
        // scaling is applied on the node's children. If done on the node itself, it changes its width and causes issues when scrolling/swiping.
        for (let ch of nd.children){
          ch.style.transition = `transform ${this.transitionDuration}ms`
        }
      }
    },
    // handle attaching observer to the correct elements based on product count
    // observers are needed to properly calc pdtWidth and scrollStep on resize
    attachObserver: function() {
      // we only want to observe either .ctnr or .pdt, based on _noSiblings
      // reset observer
      if(this.resizeObs) {
        this.resizeObs.disconnect()
        // show siblings: product width depends on container width.
        if (!this._noSiblings)
          this.resizeObs.observe(this.$el.getElementsByClassName('ctnr')[0])
        else if (this._noSiblings){
          // .pdt elements will not alway be rendered to DOM depending on when attachObserver is called
          // wait for next tick to ensure .pdt elements will always be rendered to the DOM
          this.$nextTick().then(() => {
            const target = this.$el.getElementsByClassName('pdt')[0]
            if (target)
              this.resizeObs.observe(target)
          })
        }
      }
    },

    // current selection must be in the middle of the array, or the index before if product count is even.
    // Move product to adjust selection: first elements are moved at the end, or last elements moved in first position.
    // We only manipulate the DOM nodes, not the underlying products array.
    reorderNodes: function(){
      let selectedNodeIdx = -1

      // if products array is updated, the existing node list may already be rearranged. Selected product idx (in array) may be
      // different than its actual position in node array. So we get its index in node array rather than its index in product array.
      const pdtNds = this.$el.getElementsByClassName('pdt'),
            idx = this.productIdx.toString()

      for (let i = 0; i < pdtNds.length; i++){
        if (pdtNds[i].dataset.idx === idx){
          selectedNodeIdx = i
          break
        }
      }

      if (selectedNodeIdx === -1){
        console.error('Cannot find selected product in node list.')
        return
      }

      const targetIdx  = Math.ceil(this.$data._products.length / 2 ) - 1,
            dist = selectedNodeIdx - targetIdx,
            content = this.$el.getElementsByClassName('content')[0]
      for (let i = 0; i < Math.abs(dist); i++){
        if (dist > 0)
          content.appendChild(content.firstElementChild)
        else
          content.insertBefore(content.lastElementChild, content.firstElementChild)
      }
    },

    // remove all product nodes and reinsert them in the natural order
    resetNodeList: function(){
      const content = this.$el.getElementsByClassName('content')[0],
            nodes = []
      // remove all nodes
      while(content.children.length > 0){
        const nd = content.children[0]
        nodes.push(content.removeChild(nd))
      }
      // sort them
      nodes.sort((a,b) => {
        const ia = parseInt(a.dataset.idx, 10),
              ib = parseInt(b.dataset.idx, 10)
        if (ia < ib) return -1
        else if (ia > ib) return 1
        return 0
      })
      // re-insert
      for (let i = 0; i < nodes.length; i++){
        content.appendChild(nodes[i])
      }
    },

    // on productIdx or product list update:
    // - update siblingsIdx array
    // - bind click event on siblings, unbind on previous siblings.
    updateSiblings: async function(waitDOM){
      // unbind on previous siblings before updating the siblingsIdx array (as sibling class is applied depending on this array)
      const oldSibs = this.$el.getElementsByClassName('sibling')
      for (let i = 0; i < oldSibs.length; i++){
        oldSibs[i].removeEventListener('click', this.siblingClickHandler)
      }

      // update siblings array
      if (this.$data._products.length > 1){
        this.siblingsIdx = [
          (this.productIdx + 1 ) % this.$data._products.length,
          this.productIdx - 1 >= 0 ? this.productIdx  - 1 : this.$data._products.length - 1
        ]
      }
      else
        this.siblingsIdx = []

      // when this watcher runs for the first time (productidx set by init method), DOM may not be completely rendered.
      // $nextTick awaits rendering, so the querySelector can select the elements
      if (waitDOM)
        await this.$nextTick()

      const sibs = this.$el.querySelectorAll(`.pdt[data-idx="${this.siblingsIdx[0]}"], .pdt[data-idx="${this.siblingsIdx[1]}"]`)
      for (let nd of sibs )
        nd.addEventListener('click', this.siblingClickHandler)
    },

    // moves slider to show to next/previous product
    // direction: 1 to show next product, -1 for previous product
    select: function(direction, auto = false){
      // a click on mobile on the left/right button triggers touchstart & touchend events, with the same coordinate so direction is 0.
      // Just ignore it, as the click event is triggered right after, and can processed normally.
      if (!direction || this.$data._delayedSlideWip) return

      // cancel auto-slide when user slides manually
      if (this.autoSlideItvId && !auto)
        clearInterval(this.autoSlideItvId)

      // get index of product to show
      let nextIdx = (this.productIdx + direction) % this.$data._products.length
      if (nextIdx < 0)
        nextIdx = this.$data._products.length - 1

      this.scrollOffset += this.scrollStep * -direction

      if (this._noSiblings)
        this.simpleSlide(direction)
      else
        this.slideWithSiblings(direction)

      this.productIdx = nextIdx // set new selected node
      this.$emit('product-select', this.$data._products[this.productIdx])

      if (this.pagination && !this.paginationRequested && this.productIdx >= this.$data._products.length - 4){
        this.$emit('pagination-request')
        this.paginationRequested = true
      }
    },

    // handler for click on sibling product.
    // Use targetIdx to determine if we should go to next or previous product.
    siblingClickHandler: function(e){
      const targetIdx = parseInt(e.currentTarget.dataset.idx, 10)
      let direction = 0

      if (this.productIdx === 0) // e.g. 2 0 1 (previous - current - next)
        direction = targetIdx === this.productIdx + 1 ? 1 : -1
      else if (this.productIdx === this.$data._products.length - 1) // e.g 1 2 0
        direction = targetIdx === 0 ? 1 : - 1
      else // default case, e.g. 0 1 2
        direction = targetIdx > this.productIdx ? 1 : -1

      this.select(direction)
    },

    // simple slide: just move the item opposite slide direction to the other end.
    // If slide right, first node is moved to last position.
    // On slide left, last node is moved to first position.
    simpleSlide: function(direction){
      const contentNd = this.$el.getElementsByClassName('content')[0]

      if (!contentNd) return

      if (direction > 0){
        if (this.$data._products.length > 2)
          contentNd.appendChild(contentNd.firstElementChild)
      }
      else{
        contentNd.insertBefore(contentNd.lastElementChild, contentNd.firstElementChild)
      }

      // special case for 2 products, sliding right: first node is moved after the transition duration, as well as position offset update.
      if (direction > 0 && this.$data._products.length <= 2){
        setTimeout(() => {
          contentNd.appendChild(contentNd.firstElementChild)
          this.positionOffset += this.scrollStep * direction
        }, this.transitionDuration)
      }
      else
        this.positionOffset += this.scrollStep * direction
    },

    slideWithSiblings: function(direction){
      // if only 4 products or less and sliding right, node reordering step and position adjustment must be delayed.
      // Otherwise the prev sibling product is immedialy moved to the end of the array and disappears from it initial position
      // before the animation is done, which is ugly.
      if (direction > 0 && this.$data._products.length <= 4){ // delay position adjustment
        setTimeout(()=> { this.positionOffset += this.scrollStep * direction }, this.transitionDuration)
      }
      else
        this.positionOffset += this.scrollStep * direction

      const contentNd = this.$el.getElementsByClassName('content')[0]

      if (direction > 0){
        if (this.$data._products.length > 4)
          contentNd.appendChild(contentNd.firstElementChild)
        else if (this.$data._products.length === 4) { // delay node reordering
          setTimeout(()=> { contentNd.appendChild(contentNd.firstElementChild) }, this.transitionDuration)
        }
        else{
          this.$data._delayedSlideWip = true
          // 3 elements: clone the disappearing sibling (previous one) and put it in last position so that it shows at both positions.
          // When transition is complete, remove the clone and put original node back in last position
          const nd = contentNd.querySelector(`[data-idx="${this.productIdx}"]`).previousElementSibling,
                copy = nd.cloneNode(true)
          contentNd.appendChild(copy)
          nd.style.opacity = 0 // make it disappear with transition
          setTimeout(() => {
            contentNd.removeChild(copy)
            nd.style.opacity = '' // show as intended
            contentNd.appendChild(contentNd.firstElementChild)
            this.$data._delayedSlideWip = false
          }, this.transitionDuration)
        }
      }
      // sliding left with only 3 products: clone disappearing sibling (next one) and put it in last position.
      // when transition is complete, remove the clone and put original sibling node back in first position
      else if (direction < 0 && this.$data._products.length === 3){
        this.$data._delayedSlideWip = true
        const nd = contentNd.querySelector(`[data-idx="${this.productIdx}"]`).nextElementSibling,
              copy = nd.cloneNode(true)
        contentNd.insertBefore(copy, contentNd.firstElementChild)
        nd.style.opacity = 0
        setTimeout(() => {
          contentNd.removeChild(copy)
          nd.style.opacity = ''
          contentNd.insertBefore(nd, contentNd.firstElementChild)
          this.$data._delayedSlideWip = false
        }, this.transitionDuration)
      }
      else
        // direction is -1, more than 3 products: just move the last product to the front.
        contentNd.insertBefore(contentNd.lastElementChild, contentNd.firstElementChild)
    },

    // On touch start, prepare for swipe
    swipeStart: function(e){
      // touchstart is bound whatever the product count is,
      // don't do anything if not enough to slide.
      if (this.$data._products.length < 2)
        return

      this._swipeStart = e.touches[0].screenX // x coordinate when beginning to swipe

      this._offsetBeforeSwipe = this.scrollOffset // store offset as it is before the swipe starts
      this.transitionDuration = 0 // no transition when moving for touchmove preview

      // bind touchmove event so that we can slide a bit as the finger moves
      this.$el.addEventListener('touchmove', this.previewMove, { passive: true })
    },

    // swipe: show
    swipe: function(e){
      this.$el.removeEventListener('touchmove', this.previewMove)

      // event is bound whatever the product count is,
      // don't do anything if not enough to slide.
      if (this.$data._products.length < 2)
        return

      this.transitionDuration = this.slideDuration // revert transition to its normal value
      this.scrollOffset = this._offsetBeforeSwipe // reset offset to before swipe, so that calculations in select method use the correct starting point
      const swipeLength = this._swipeStart - e.changedTouches[0].screenX

      // Ignore swipe if it's too short. Browsers have a tolerance for touch clicks; moving the finger a bit before releasing triggers a click AND a swipe, skipping a product.
      if (Math.abs(swipeLength) < 20)
        return

      const direction = Math.sign(swipeLength)
      this.select(direction)      
    },

    // when moving with finger on screen, start sliding as the finger moves
    previewMove: function(e){
      let len = this._swipeStart - e.touches[0].screenX // length between swip start and now
      const direction = len > 0 ? 1 : -1

      // reduce scroll offset if moved more than 1 product's width
      if (Math.abs(len) > this.scrollStep)
        len = (this.scrollStep + (Math.abs(len) - this.scrollStep) * .2) * direction

      // move container in the same proportion as the finger moved
      this.scrollOffset = this._offsetBeforeSwipe - len
    },

    arrowNav: function(e){
      const direction = e.key === 'ArrowLeft' ? -1 : 1
      this.select(direction)
    },
  },
  template: `
    <div class="product-slider" v-on:touchstart.stop.passive="swipeStart"
        v-on:touchend.stop.passive="swipe" :class="{'no-sibling': _noSiblings}"
        :aria-label="i18n.getString('PRODUCT_SLIDER_LBL')" :tabindex="$data._products.length > 1 ? '0' : ''"
        v-on:keydown.self.stop.passive.left.right="arrowNav"
        role="listbox" :aria-activedescendant="'pdt_'+ productIdx"
        aria-orientation="horizontal">

      <div v-on:click.stop.passive="select(-1)" v-on:keypress.stop.passive.enter="select(-1)"
          class="slide-btn left" :class="{disabled: hideSlideButtons || pagination && productIdx === 0}"
          tabindex="0" role="button" :aria-label="i18n.getString('SELECT_PREVIOUS_PRODUCT', 'name', previousLabel)">
        <div class="picto" role="presentation"></div>
      </div>

      <div class="ctnr" role="presentation">
        <div class="content" :style="ctnrStyle" role="presentation">
          <div v-for="(pdt, i) in $data._products" class="pdt"
              :id="'pdt_' + i"
              :class="{selected: i === productIdx, sibling: siblingsIdx.includes(i), wl: i === productIdx}"
              :data-idx="i" :style="pdtStyle"
              :aria-label="i === productIdx ? pdt.name + ' ' + pdt.pkg: ''"
              :aria-selected="(i === productIdx).toString()" :aria-current="(i === productIdx).toString()"
              role="option">
            <slot v-bind:pdt="pdt" v-bind:i="i">
            </slot>
          </div>
        </div>
      </div>

      <div v-on:click.stop.passive="select(1)" v-on:keypress.stop.passive.enter="select(1)"
          class="slide-btn right" :class="{disabled: hideSlideButtons || pagination && productIdx === $data._products.length - 1}"
          tabindex="0" role="button" :aria-label="i18n.getString('SELECT_NEXT_PRODUCT', 'name', nextLabel)">
        <div class="picto" role="presentation"></div>
      </div>

      <div id="ta-announce" aria-live="polite">{{currentLabel}}</div>
    </div>
  `
})
